import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SubHeaderLayout } from '@presentation/layouts';

@Component({
  selector: 'cm-requestor-info-section',
  standalone: true,
  imports: [SubHeaderLayout],
  templateUrl: './requestor-info-section.component.html',
  styleUrl: './requestor-info-section.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestorInfoSectionComponent {
  public readonly requestorData = input.required<{
    name: string;
    email: string;
    phone: string;
    division?: string | null;
    department?: string | null;
  }>();
}
